var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['impressao-bloco', { 'impressao-bloco-max-width-meio': _vm.meio }]},[_c('h3',[_vm._v(_vm._s(_vm.nome))]),_c('p',[_vm._v(_vm._s(_vm.dado))])])}
var staticRenderFns = []

export { render, staticRenderFns }